export default __webpack_public_path__ + "static/media/ami4.a08b4da0.jpg";